import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import {
    TWITCH_OAUTH_URL, TWITCH_CLIENT_ID,
    REDIRECT_URI, TWITCH_SECRET,    
} from '../constants/twitchConstants';
import { loginUser } from "../utils/loginHelper";
let backendAPIURL = 'https://be.namasteapis.com/api/v1';


export const axiosCall = (route) => {
  console.log('request:- ' + JSON.stringify(route));
  return new Promise(async (resolve, reject) => {
    return axios(route)
      .then((res) => {
        //console.log('Response:- ' + JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        //console.log('error:- ' + error);
        reject(error.response);
      });
  });
};

export async function loginYoutubeAPI(
    youtubeCode: any, socketId:any) {
    const request = {
        method: 'POST',
        url: `${backendAPIURL}/auth/youtube/login/?web=true`,
        'data': {
            'code':youtubeCode,
            'socketId': socketId,
            'device': 'web3'
        }
    };
    let res = await axiosCall(request);
    if (res.data.success) {
        return res.data;
    }
    else {
        return;
    }
}

export default function YoutubeSuccessLoginComponent(props) {
    
    useEffect(()=>{
        (async ()=>{
            const urlSearchParams = new URLSearchParams(
                window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            let code = params['code'];
            let socketId = params['state'];
            if(socketId.includes('oldURL')){
                let loginData = await loginYoutubeAPI(
                    code, 'gg boys no need for this');
                const myArray = socketId.split("oldURL-");
                loginUser(loginData)
                let oldURL = myArray[1];
                window.location.replace(oldURL);
                return;
            }
            let accessToken = await loginYoutubeAPI(code, socketId);
	    window.close()
        })();
    },[]);
    
    return (<></>);
}
